const consoleLog = (...args) => {
	if(process.env.REACT_APP_ENV == "DEV"){
		for (var i = 0; i < args.length; i++) {
	    	console.log(args[i]);
	  	}
	}
}

export default consoleLog;